import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;

  > section {
    display: -webkit-inline-box;
    justify-content: center;
    align-items: center;
    width: auto;
    margin: 1rem auto 0;
    border-radius: 12px;
    position: relative;
    padding: 7px 0;
    
    background: ${props => props.theme.cards.primary};
    border: 1px solid ${props => props.theme.cards.border};
    box-shadow: ${props => props.theme.shadows.primary};
    border-radius: ${props => props.theme.radius.primary};

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      &:nth-child(1) {
        transform: rotate(180deg);

        &::before {
          content: "";
          width: 1px;
          height: 20px;
          background-color: #adafca70;
          position: absolute;
          top: calc(50% - 10px);
          left: 0;
        }
      }

      &:last-child {
        &::before {
          content: "";
          width: 1px;
          height: 20px;
          background-color: #adafca70;
          position: absolute;
          top: calc(50% - 9px);
          left: 0;
        }
      }

      > button {
        display: flex;
        text-decoration: none;
        color: ${props => props.theme.colors.white} !important;
        background: transparent;
        padding: 0 15px;
        border-radius: 12px;
        font-size: .875rem;
        font-weight: 600;
        line-height: 0;
        transition: all .25s ease-in-out;
        margin: 0 .5rem;
        border: none;
        cursor: pointer;

        > span {
          line-height: 0;
        }

        &[disabled] {
          color: #adafca70 !important;
          cursor: default;
        }
      }
    }

    > ul {

      > li {
        display: inline-flex;
        position: relative;
        padding: 0 .5rem;

        &:not(:first-child):before {
          content: "";
          width: 1px;
          height: 20px;
          background: #adafca70;
          position: absolute;
          top: calc(50% - 10px);
          left: 0;
        }

        > button, a {
          text-decoration: none;
          background: transparent;
          color: ${props => props.theme.colors.white};
          padding: 23px 15px;
          border-radius: 12px;
          font-size: .875rem;
          font-weight: 600;
          line-height: 0;
          border: none;
          cursor: pointer;
          transition: all .25s ease-in-out;

          &:hover {
            background-color: ${props => props.theme.colors.primary};
            color: #fff;
            box-shadow: ${props => props.theme.colors.shadowMenu};
          }

          &.active {
            background-color: ${props => props.theme.colors.primary};
            color: #fff;
            box-shadow: ${props => props.theme.colors.shadowMenu};
          }
        }
      }
    }
  }

`;
